import { isNotNil, setTrackingId } from "client/Misc/utils";
import {
	PropsWithChildren,
	ReactElement,
	useCallback,
	useContext
} from "react";
import styles from "./GlobalSearchItem.module.less";
import { DropOverContext } from "client/Components";

export type GlobalSearchItemProps = {
	onClick: () => void;
	shouldNotAutoCloseContainingDropOver?: boolean;
	trackingId?: string;
};

export const GlobalSearchItem = (props: PropsWithChildren<GlobalSearchItemProps>): ReactElement => {
	const {
		trackingId,
		children,
		onClick,
		shouldNotAutoCloseContainingDropOver
	} = props;

	const {
		onClose: onCloseDropOver
	} = useContext(DropOverContext);

	const clickHandler = useCallback(
		(): void => {
			if (!shouldNotAutoCloseContainingDropOver && isNotNil(onCloseDropOver)) {
				onCloseDropOver();
			}

			onClick();
		},
		[
			shouldNotAutoCloseContainingDropOver,
			onCloseDropOver,
			onClick
		]
	);

	return (
		<li
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<div
				{...setTrackingId(trackingId, "__clickable-area")}
				onClick={clickHandler}
				className={styles.container}
			>
				{children}
			</div>
		</li>
	);
};

GlobalSearchItem.displayName = "GlobalSearchItem";
